<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="invoice-page" v-if="isMounted">
    <div
      class="flex flex-wrap items-center justify-between"
      v-if="getMainInfo.poStatus == 'Approved PO'"
    >
      <div class="flex items-center">
        <vs-button
          class="mb-base mr-3"
          icon-pack="feather"
          icon="icon icon-file"
          @click="printInvoice"
        >Print</vs-button>
      </div>
    </div>

    <vx-card id="invoice-container">
      <!-- INVOICE METADATA -->
      <div class="vx-row leading-loose p-base">
        <div class="vx-col w-1/2 mt-base">
          <img height="200px" :src="getLogo" alt="vuexy-logo" />
          <vs-row>
            <vs-col>{{ userDetails.billingAddress.billAddress1 }}</vs-col>
          </vs-row>
          <vs-row>
            <vs-col>{{ userDetails.billingAddress.billAddress2}}</vs-col>
          </vs-row>
          <vs-row>
            <vs-col>Tel: {{userDetails.billingAddress.contactNumber}} Fax: {{ userDetails.billingAddress.faxNumber}}</vs-col>
          </vs-row>
        </div>
        <div class="vx-col w-1/2 text-right">
          <h1>{{title}}</h1>
          <div class="invoice__invoice-detail mt-6"> 
            <p class="font-bold text-lg">{{showLabel}} NO.: {{ getMainInfo.poNumber }}</p>
 
            <p class="font-bold text-lg">{{showLabel}} DATE : {{ getMainInfo.poDate }}</p>
 
            <p class="font-bold text-lg">JOB NO.: {{ getMainInfo.poJobNo }}</p>
 
            <p class="font-bold text-lg">PR NO. : {{ getMainInfo.poPrNumber }}</p>
          </div>
        </div>
      </div>

      <div class="p-base">
        <vs-row>
          <vs-col vs-w="5">
            <div class="vx-col mt-base text-xl font-bold bg-grey p-2">Vendor</div>
            <vs-row>{{ userDetails.vendor.companyName }}</vs-row>
            <vs-row>{{ userDetails.vendor.address1 }}</vs-row>
            <vs-row>{{ userDetails.vendor.address2 }}</vs-row>
            <vs-row>{{ userDetails.vendor.contactNo }}</vs-row>
          </vs-col>

          <vs-col vs-offset="2" vs-w="5">
            <div class="vx-col mt-base text-xl font-bold bg-grey p-2">Bill & Ship To</div>
            <vs-row>{{ userDetails.branch.branchName }}</vs-row>
            <vs-row>{{ userDetails.billingAddress.billAddress1 }}</vs-row>
            <vs-row>{{ userDetails.billingAddress.billAddress2 }}</vs-row>
            <vs-row>{{ userDetails.billingAddress.contactNumber }}</vs-row>
          </vs-col>
        </vs-row>
      </div>

      <!-- INVOICE CONTENT -->
      <div class="p-base">
        <p class>Dear Sir/Madam,</p>
        <p class>We hereby confirmed the following:</p>
        <!-- INVOICE TASKS TABLE -->
        <vs-table hoverFlat :data="userDetails.items">
          <!-- HEADER -->
          <template slot="thead">
            <vs-th class="pointer-events-none">Item Code</vs-th>
            <vs-th class="pointer-events-none">Item Description</vs-th>
            <vs-th class="pointer-events-none">Qty.</vs-th>
            <vs-th class="pointer-events-none">Price</vs-th>
            <vs-th class="pointer-events-none">Total Amount</vs-th>
          </template>

          <!-- DATA -->
          <template slot-scope="{data}">
            <vs-tr v-for="(tr, index) in data" :key="index">
              <vs-td :data="data[index].itemName">{{ data[index].itemName }}</vs-td>
              <vs-td :data="data[index].description">{{ data[index].description }}</vs-td>
              <vs-td :data="data[index].qty">{{ data[index].qty }}</vs-td>
              <vs-td
                :data="data[index].price"
              >{{ data[index].price }} {{ userDetails.currency.currencyName}}</vs-td>
              <vs-td
                :data="data[index].total"
              >{{ data[index].total }} {{ userDetails.currency.currencyName}}</vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <!-- INVOICE SUMMARY TABLE -->
        <vs-table hoverFlat class="w-1/2 ml-auto mt-4" :data="userDetails.items">
          <vs-tr>
            <vs-th class="pointer-events-none">SUBTOTAL</vs-th>
            <vs-td>{{ getMainInfo.subTotal }} {{ userDetails.currency.currencyName}}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th class="pointer-events-none">TAX ({{ getMainInfo.tax }}%)</vs-th>
            <vs-td>{{ getTax() }} {{ userDetails.currency.currencyName}}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th class="pointer-events-none">TOTAL</vs-th>
            <vs-td>{{ getMainInfo.total }} {{ userDetails.currency.currencyName}}</vs-td>
          </vs-tr>
        </vs-table>
      </div>

      <div class="p-1">
        <vs-table hoverFlat class="w-full" :data="userDetails.items">
          <vs-tr class>
            <vs-th>
              <div class="w-full bg-grey p-3">
                <div class="text-center">PREPARED</div>
              </div>
            </vs-th>
            <vs-th class="pointer-events-none">
              <div class="w-full bg-grey p-3">
                <div class="text-center">VERIFIED</div>
              </div>
            </vs-th>
            <vs-th class="pointer-events-none">
              <div class="w-full bg-grey p-3">
                <div class="text-center">APPROVED</div>
              </div>
            </vs-th>
          </vs-tr>
          <vs-tr>
            <vs-td class="pointer-events-none">
              <div class="w-full">
                <div class="text-center">
                  <p>Procurement Department</p>
                  <div class="font-light italic">{{ parseFromISOToLong(getMainInfo.created_at) }}</div>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <div class="w-full">
                <div class="text-center">
                  <p>Balachandar Ramani</p>
                  <div
                    class="font-light italic"
                  >{{ parseFromISOToLong(getMainInfo.approvedFinance) }}</div>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <div class="w-full">
                <div class="text-center">
                  <p>Taufik Othman</p>
                  <div class="font-light italic">{{ parseFromISOToLong(getMainInfo.approvedMd) }}</div>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </vs-table>
      </div>

      <!-- INVOICE FOOTER -->
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/axios.js";

import { axiosMixin } from "../../../mixin/axiosMixin";
import { helperMixin } from "../../../mixin/helperMixin";
import { alertMixin } from "../../../mixin/alertMixin";

export default {
  props: {
    title: String
  },
  mixins: [axiosMixin, helperMixin, alertMixin],
  data() {
    return {
      isMounted: false,
      mailTo: "",
      userDetails: {}
    };
  },
  computed: {
    ...mapGetters({
      getSystemSettings: "auth/getSystemSettings", 
      getMainInfo: "profile/getMainInfo"
    }),
    showLabel() {
      return "PO";
    },
    getLogo() { 
      return axios.defaults.baseURL + "/storage/" + this.getSystemSettings.logo;
    }
  },
  methods: {
    printInvoice() {
      let routeData = this.$router.resolve({
        name: "PO",
        query: {
          poCurrency: this.getMainInfo.poCurrency,
          userId: this.getMainInfo.userId,
          poVendorId: this.getMainInfo.poVendorId,
          id: this.getMainInfo.id,
          logo:this.getSystemSettings.logo,
        }
      });
      window.open(routeData.href, "_blank");
    },
    getTax() {
      return (
        (parseInt(this.getMainInfo.tax) / 100) *
        parseInt(this.getMainInfo.subTotal)
      );
    },
    getUserPRUserInfo() {
      this.aronPost(
        "poDetails",
        {
          poCurrency: this.getMainInfo.poCurrency,
          userId: this.getMainInfo.userId,
          vendorId: this.getMainInfo.poVendorId,
          poId: this.getMainInfo.id
        },
        "",
        ""
      )
        .then(response => {
          console.log("userInfo:", response.data);
          this.userDetails = response.data;
          this.isMounted = true;
        })
        .catch(error => {
          this.decodeErrorFromAxios(error);
        });
    }
  },
  components: {},
  mounted() {
    console.log("getMainInfo:", this.getMainInfo);
    this.getUserPRUserInfo();
    this.$emit("setAppClasses", "invoice-page");
  },
  created() {
    this.isMounted = false;
  }
};
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>
